import React, { useState, useEffect, useCallback } from "react";
import SecuritiesCompanyBoard from "src/components/home/SecuritiesCompanyBoard";
import { useSelector } from "react-redux";
import { RootState } from "src/store/store";
import { ListParam, defaultListParam } from "src/types/api/listParam";
import { getCorp, getSector } from "src/api/ChannelApi";

interface SecuritiescompanyContainerProps {
    rowPerPage: number;
}
  
const SecuritiescompanyContainer: React.FC<SecuritiescompanyContainerProps> = ({ rowPerPage }) => {
    const companyCorpId = useSelector((state: RootState) => state.category.companyCorpId);
    const companySectorId = useSelector((state: RootState) => state.category.companySectorId);
    const companyTab = useSelector((state: RootState) => state.tab.companyTab);
    const [curPage, setCurPage] = useState(null);
    const [companycontents, setCompanyContents] = useState([]);
    const [date, setDate] = useState('')
    const [isMore, setIsMore] = useState(true);
    
    const fetchData = useCallback(async (params: ListParam) => {
        try{
            let response;
            if (companyTab === "증권사"){
                response = await getCorp(params);
            }
            else if (companyTab === "업종"){
                response = await getSector(params);
            }
        
            const newData = response?.data?.list || [];
            if ( newData.length < rowPerPage ){
                setIsMore(false)
            } else {
                setIsMore(true)
            }
            if (params.curPage === 1) {
                setCompanyContents(newData);
                setDate(response?.data?.param.yyyymmdd || [])
            } else {
                setCompanyContents((prevData) => [...prevData, ...newData]); 
            }
        } catch (error) {
            console.error("API 호출 실패:", error);
            if (params.curPage === 1) setCompanyContents([]);
        }
    }, [rowPerPage, companyTab]);
      
    useEffect(() => { 
        setCurPage(null);
        const defaultParams = defaultListParam();
        if (companyTab === "증권사"){
            defaultParams.corp_id = companyCorpId
        }
        else if (companyTab === "업종"){
            defaultParams.sector_id = companySectorId
        }
        defaultParams.rowPerPage = rowPerPage;
        fetchData(defaultParams);
    }, [companyCorpId, companySectorId, companyTab, rowPerPage, fetchData]);

    const handleLoadMore = async () => {
        try {
            const defaultParams = defaultListParam();
            const newPage = curPage === null ? 2 : curPage + 1;
            if (companyTab === "증권사"){
                defaultParams.corp_id = companyCorpId
            }
            else if (companyTab === "업종"){
                defaultParams.sector_id = companySectorId
            }
            defaultParams.curPage = newPage;
            defaultParams.rowPerPage = rowPerPage;
            defaultParams.yyyymmdd = date;
            await fetchData(defaultParams);
            setCurPage(newPage);
        } catch (error) {
            console.error("추가 데이터 로드 실패:", error);
        }
    };

    return (
        <SecuritiesCompanyBoard contents={companycontents} isMore={isMore} handleLoadMore={handleLoadMore} date={date} />
    );
};

export default SecuritiescompanyContainer;
